{
  "FILTER": {
    "AI_PROMPT": "Filtru AI",
    "TITLE": "Filtrarea conversațiilor",
    "SUBTITLE": "Add your filters below and hit 'Apply filters' to cut through the chat clutter.",
    "EDIT_CUSTOM_FILTER": "Editare folder",
    "CUSTOM_VIEWS_SUBTITLE": "Adaugă sau elimină filtrele și actualizează folderul.",
    "ADD_NEW_FILTER": "Add filter",
    "FILTER_DELETE_ERROR": "Oops, looks like we can't save nothing! Please add at least one filter to save it.",
    "SUBMIT_BUTTON_LABEL": "Aplicarea filtrelor",
    "UPDATE_BUTTON_LABEL": "Dosar actualizare",
    "CANCEL_BUTTON_LABEL": "Renunță",
    "CLEAR_BUTTON_LABEL": "Clear filters",
    "FOLDER_LABEL": "Nume folder",
    "TEAMS_LABEL": "Partajează cu",
    "PARENT_FOLDER_LABEL": "Dosar părinte",
    "NO_PARENT_FOLDER": "Fără dosar părinte",
    "BACKGROUND_COLOR_LABEL": "Culoare de fundal",
    "COLOR_LABEL": "Culoare",
    "SELECT_COLOR": "Selectați culoarea",
    "CLEAR_SELECTION": "Șterge selecția",
    "SORT_BY_LABEL": "Sortează după",
    "FOLDER_QUERY_LABEL": "Interogare folder",
    "EMPTY_VALUE_ERROR": "Este necesară o valoare validă.",
    "TOOLTIP_LABEL": "Filtrarea conversațiilor",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "ȘI",
      "OR": "SAU"
    },
    "INPUT_PLACEHOLDER": "Enter value",
    "OPERATOR_LABELS": {
      "present": "Prezent",
      "not_present": "Nu este prezent",
      "present_with_answer": "Prezent cu răspuns",
      "present_without_answer": "Prezent fără răspuns",
      "equal_to": "Egal cu",
      "not_equal_to": "Nu este egal cu",
      "does_not_contain": "Nu conține",
      "is_present": "Este prezent",
      "is_not_present": "Nu este prezent",
      "is_greater_than": "Este mai mare decât",
      "is_less_than": "Este mai mică decât",
      "is_greater_than_or_equal": "Este mai mare sau egal cu",
      "is_less_than_or_equal": "Este mai mic sau egal cu",
      "newer_than_days": "Este mai nou decât x zile (inclusiv)",
      "older_than_days": "Este mai vechi decât x zile (inclusiv)",
      "starts_with": "Începe cu",
      "equalTo": "Egal cu",
      "notEqualTo": "Nu este egal cu",
      "contains": "Conține",
      "doesNotContain": "Nu conține",
      "isPresent": "Este prezent",
      "isNotPresent": "Nu este prezent",
      "isGreaterThan": "Este mai mare decât",
      "isLessThan": "Este mai mică decât",
      "isGreaterThanOrEqual": "Este mai mare sau egal cu",
      "isLessThanOrEqual": "Este mai mic sau egal cu",
      "startsWith": "Începe cu"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Adevărat",
      "FALSE": "Fals"
    },
    "ATTRIBUTES": {
      "STATUS": "Status",
      "ASSIGNEE_NAME": "Assignee name",
      "INBOX_NAME": "Nume Inbox",
      "TEAM_NAME": "Numele echipei",
      "CONVERSATION_IDENTIFIER": "Conversation identifier",
      "CAMPAIGN_NAME": "Campaign name",
      "LABELS": "Etichete",
      "BROWSER_LANGUAGE": "Browser language",
      "PRIORITY": "Prioritate",
      "COUNTRY_NAME": "Country name",
      "REFERER_LINK": "Link referer",
      "CUSTOM_ATTRIBUTE_LIST": "Listă",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Număr",
      "CUSTOM_ATTRIBUTE_LINK": "Legătură",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Căsuță de bifat",
      "CREATED_AT": "Creat la",
      "LAST_ACTIVITY": "Ultima activitate",
      "LAST_CUSTOMER_MESSAGE_AT": "Ultimul mesaj al clientului",
      "PHONE_CALL": "Apel telefonic",
      "RATING": "Evaluare",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "Primit",
      "OUTBOUND": "Efectuat",
      "MISSED": "Ratat",
      "UNHANDLED_MISSED": "Ratat fără răspuns"
    },
    "RATING_TYPES": {
      "UP": "Degetul mare în sus",
      "DOWN": "Degetul mare în jos"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Este necesară o valoare validă",
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Valoarea trebuie să fie între 0 și 998",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standard filters",
      "ADDITIONAL_FILTERS": "Additional filters",
      "CUSTOM_ATTRIBUTES": "Custom attributes"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Doriți să salvați acest filtru?",
        "LABEL": "Denumiți acest filtru",
        "PLACEHOLDER": "Name your filter to refer it later.",
        "ERROR_MESSAGE": "Numele este obligatoriu.",
        "SAVE_BUTTON": "Salvare filtru",
        "CANCEL_BUTTON": "Renunță",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Folder creat cu succes.",
          "ERROR_MESSAGE": "Eroare la crearea folderului."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment creat cu succes.",
          "ERROR_MESSAGE": "Eroare la crearea segmentului."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Editare folder",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Eroare la actualizarea folderului."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Ștergere filtru",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Confirmă ștergerea",
            "MESSAGE": "Sunteți sigur că ștergeți filtrul ",
            "YES": "Yes, delete",
            "NO": "Nu, păstreaza"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Folder șters cu succes.",
          "ERROR_MESSAGE": "Eroare la ștergerea folderului."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Contact șters cu succes.",
          "ERROR_MESSAGE": "Eroare la ștergerea segmentului."
        }
      }
    }
  }
}
